import type { ShowArticleProps } from "../../../react4xp/parts/showArticle/ShowArticleProps.d";

import React from 'react';
import { ShowArticle } from "/react4xp/parts/showArticle/ShowArticle";


export default function (props: ShowArticleProps): React.JSX.Element {
	return <ShowArticle {...props} />;
}
